/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/by_section.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpBySectionIndex {
  constructor() {
    this.sections_options = {};
    this.currentSection = 0;
  }

  registerOption(opt) {
    if (typeof this.sections_options[this.currentSection] === 'undefined') this.sections_options[this.currentSection] = {};
    this.sections_options[this.currentSection][opt] = true;
  }

  loadSectionOptions(sec) {
    this.currentSection = sec;
    if (this.sections_options[sec]) return Object.keys(this.sections_options[sec]);
    return [];
  }
}

export default LpBySectionIndex;



// WEBPACK FOOTER //
// ./src/app/indexes/by_section.js